import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

export const StartRentalButtonScreenshot = () => (
    <div className='pointer-events-none user-select-none padding-15 bg-lighter'>
        <Button bsStyle='primary' iconName='ok-dashed'>
            <FormattedMessage id='intl-msg:rental-web.dialog.start-rental.button.title' />
        </Button>
    </div>
);
